<template>
	<div class="d-flex flex-column align-center wrapper-counter" :style="isWhite">
		<label
			v-if="title"
			class="label"
		>{{title}}</label>
		<div class="d-flex">
			<div class="d-flex flex-column align-center">
				<div class="d-flex">
					<p
						:class="[
							'card',
							{ 'dark-card': darkTheme },
						]"
						v-for="(hour, indexHour) in hours" :key="indexHour"
					>
						{{hour}}
					</p>
				</div>
				<span v-if="showTimeWords">HORAS</span>
			</div>
			<span
				:class="[
					'dots',
					{ 'dark-dots': darkTheme },
				]"
			> : </span>
			<div class="d-flex flex-column align-center">
				<div class="d-flex">
					<p
						:class="[
							'card',
							{ 'dark-card': darkTheme },
						]"
						v-for="(minute, indexMinute) in minutes" :key="indexMinute"
					>
						{{minute}}
					</p>
				</div>
				<span v-if="showTimeWords">MINUTOS</span>
			</div>
			<span
				:class="[
					'dots',
					{ 'dark-dots': darkTheme },
				]"
			> : </span>
			<div class="d-flex flex-column align-center">
				<div class="d-flex">
					<p
						:class="[
							'card',
							{ 'dark-card': darkTheme },
						]"
						v-for="(second, indexSecond) in seconds" :key="indexSecond"
					>
						{{second}}
					</p>
				</div>
				<span v-if="showTimeWords">SEGUNDOS</span>
			</div>
		</div>
	</div>
</template>
<script>
import { differenceInHours, differenceInMinutes, differenceInSeconds } from 'date-fns';

function created() {
	const k = (5 * 3600000);
	const endDateMiliseconds = new Date(this.endDate).getTime() + k;
	setInterval(() => {
		this.todayMiliseconds = new Date().getTime();
		this.diffHours = differenceInHours(endDateMiliseconds, this.todayMiliseconds);
		const diffMinutes = differenceInMinutes(endDateMiliseconds, this.todayMiliseconds);
		this.diffMinutes = (((diffMinutes / 60) - this.diffHours) * 60).toFixed(0);
		this.diffMinutes = this.diffMinutes.toString().length === 1
			? `0${this.diffMinutes}`
			: this.diffMinutes;
		const diffSeconds = differenceInSeconds(endDateMiliseconds, this.todayMiliseconds);
		this.diffSeconds = Math.abs(
			(((((diffSeconds / 3600) - this.diffHours) * 60) - this.diffMinutes) * 60).toFixed(0),
		);
		this.diffSeconds = this.diffSeconds.toString().length === 1
			? `0${this.diffSeconds}`
			: this.diffSeconds;
	}, 1000);
}

function hours() {
	return [...this.diffHours.toString()];
}

function minutes() {
	return [...this.diffMinutes.toString()];
}

function seconds() {
	return [...this.diffSeconds.toString()];
}

function isWhite() {
	if (this.bgWhite) {
		return 'background-color: white;';
	}
	return null;
}

function data() {
	return {
		diffHours: 0,
		diffMinutes: 0,
		diffSeconds: 0,
		todayMiliseconds: 0,
	};
}

export default {
	name: 'time-counter',
	computed: {
		hours,
		isWhite,
		minutes,
		seconds,
	},
	created,
	data,
	props: {
		bgWhite: {
			default: false,
			type: Boolean,
		},
		darkTheme: {
			default: false,
			type: Boolean,
		},
		endDate: {
			default: '',
			type: String,
		},
		showTimeWords: {
			default: false,
			type: Boolean,
		},
		title: {
			deafult: '',
			type: String,
		},
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-counter {
		padding: 0 1rem;
		max-height: 7rem;

		@media (max-width: 425px) {
			flex: 1 1 auto;
		}
	}

	.grid-system {
		display: grid;
		grid-template-columns: repeat(auto-fill, minmax(2rem, 1fr));
		grid-column-gap: 0.3rem;
	}

	.card {
		background-color: white;
		color: color(redBold);
		font-size: size(medium);
		font-weight: bold;
		height: max-content;
		margin: 0;
		padding: 0.4rem;
		text-align: center;
		width: 2.5rem;

		@media (max-width: 425px) {
			font-size: size(medium);
			padding: 0;
		}
	}

	.dark-card {
		background-color: color(defaultBlack);
		color: white;
		font-size: size(large);
		margin: 0 0.4rem 0 0;
	}

	.dots {
		font-size: size(large);
		font-weight: bold;
		margin: 0 0.2rem;
	}

	.dark-dots {
		margin: 0 1rem;
	}

	.label {
		font-weight: bold;
	}
</style>




// WEBPACK FOOTER //
// timeCounter.vue?57cbb56a